package com.oscarherreros.appcalculo.game

enum class Op(val symbol: String) {
    ADD("+"),
    SUB("−"),
    MUL("×"),
    DIV("÷");

    /** Resultado de `a op b`, o null si no es un entero positivo. */
    fun calc(a: Long, b: Long): Long? = when (this) {
        ADD -> a + b
        SUB -> (a - b).takeIf { it > 0 }
        MUL -> a * b
        DIV -> if (a % b == 0L) a / b else null
    }
}
